import { useEffect, useState } from "react";

// Tailwind `xl`. At/above it the assistant and its letters or pages sit side
// by side; below it one pane shows at a time behind a switch.
const QUERY = "(min-width: 1280px)";

export const useIsWide = (): boolean => {
  const [isWide, setIsWide] = useState(() => window.matchMedia(QUERY).matches);

  useEffect(() => {
    const query = window.matchMedia(QUERY);
    const onChange = () => setIsWide(query.matches);
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, []);

  return isWide;
};
